// extracted by mini-css-extract-plugin
module.exports = {"Selector":"Selector_Selector__31tmo"};